module.exports = __webpack_public_path__ + "img/Bepreisung_weight.a7595173.png";